import { ASSET_URL } from 'src/dataLayer/env'

// For dynamic asset handling in webpack. This config variable will set the
// base path of assets at run time. Any asset module loaded before this module
// does not apply this reconfiguration.
// See https://webpack.js.org/guides/public-path/

__webpack_public_path__ = ASSET_URL // eslint-disable-line no-undef, camelcase -- we need to set the webpack public path
